import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Read.css';
import { Switch } from 'antd';
import { useSelector } from 'react-redux';
import { GrFormClose } from 'react-icons/gr';
import { AiOutlineUnderline } from "react-icons/ai";
import { ClickAwayListener } from '@material-ui/core';
const QuickHighlightShowColorPalete = (props) => {
    const [checked, setChecked] = useState(false);
    const [quickToolON, setQuickToolON] = useState(false);
    const [selectedColor, setSelectedColor] = useState("");
    const [colorBtnTypeOne, setColorBtnTypeOne] = useState(false);
    const [colorBtnTypeTwo, setColorBtnTypeTwo] = useState(false);
    const [colorBtnTypeSix, setColorBtnTypeSix] = useState(false);
    const [colorBtnTypeTen, setColorBtnTypeTen] = useState(false);
    const [colorBtnTypeFour, setColorBtnTypeFour] = useState(false);
    const [colorBtnTypeFive, setColorBtnTypeFive] = useState(false);
    const [colorBtnTypeNine, setColorBtnTypeNine] = useState(false);
    const [selectedUnderLine, setSelectedUnderLine] = useState(false);
    const [colorBtnTypeThree, setColorBtnTypeThree] = useState(false);
    const [colorBtnTypeSeven, setColorBtnTypeSeven] = useState(false);
    const [colorBtnTypeEight, setColorBtnTypeEight] = useState(false);
    const [colorBtnTypeEleven, setColorBtnTypeEleven] = useState(false);
    const [quickHighlightColors, setQuickHighlightColors] = useState([]);
    const { removedColorsVOList } = useSelector((selectState) => selectState.userVO);
    useEffect(() => {
        let localColorId = localStorage.getItem('QuickHighSelectedColor');
        let localColorCode = localStorage.getItem('QuickHighSelectedColorCode');
        if (localColorId !== undefined && localColorId !== null && localColorId !== "" && localColorCode !== undefined && localColorCode !== null && localColorCode !== "") {
            let quickHighlightSwitchHandle1 = document.querySelector('.quickHighlightContainer button.ant-switch .ant-switch-handle');
            quickHighlightSwitchHandle1.classList.add('ant-switched-handle');
            props.handleQuickToolInputs(true, localColorCode)
            setQuickToolON(true);
        }
    }, []);
    useEffect(() => {
        let colorCodeListQuick = [
            { id: "colorBtnTypeOne", color: '#EDE48C', colorCode: '#EDE48C', title: 'Yellow', stateValue: "colorBtnTypeOne" },
            { id: "colorBtnTypeTwo", color: '#B5EB97', colorCode: '#B5EB97', title: 'Green', stateValue: "colorBtnTypeTwo" },
            { id: "colorBtnTypeThree", color: '#AEE6FE', colorCode: '#AEE6FE', title: 'Blue', stateValue: "colorBtnTypeThree" },
            { id: "colorBtnTypeFour", color: '#FEC0FF', colorCode: '#FEC0FF', title: 'Pink', stateValue: "colorBtnTypeFour" },
            { id: "colorBtnTypeFive", color: '#FFD4A8', colorCode: '#FFD4A8', title: 'Orange', stateValue: "colorBtnTypeFive" },
            { id: "colorBtnTypeSix", color: '#CBBEFC', colorCode: '#CBBEFC', title: 'Purple', stateValue: "colorBtnTypeSix" },
            { id: "colorBtnTypeSeven", color: '#35FBE2', colorCode: '#35FBE2', title: 'Cyan', stateValue: "colorBtnTypeSeven" },
            { id: "colorBtnTypeEight", color: '#95A7FF', colorCode: '#95A7FF', title: 'LightNavy', stateValue: "colorBtnTypeEight" },
            { id: "colorBtnTypeNine", color: '#FF8787', colorCode: '#FF8787', title: 'LightCoral', stateValue: "colorBtnTypeNine" },
            { id: "colorBtnTypeTen", color: '#C1A88E', colorCode: '#C1A88E', title: 'Sandrift', stateValue: "colorBtnTypeTen" },
            { id: "colorBtnTypeEleven", color: '#DADADA', colorCode: '#DADADA', title: 'Gainsboro', stateValue: "colorBtnTypeEleven" },
            { id: "underLine", color: 'underLine', colorCode: 'underLine', title: 'underLine', stateValue: selectedUnderLine }
        ];
        let hiddenColorCodesQuick = removedColorsVOList;
        if (hiddenColorCodesQuick !== null && hiddenColorCodesQuick !== undefined) {
            hiddenColorCodesQuick.map((i, index) => {
                if (i.highlightColorCode !== null) {
                    colorCodeListQuick.splice(colorCodeListQuick.findIndex(item => item.color === i.highlightColorCode), 1)
                }
            })
        }
        let colorCodeListQuick1 = [...colorCodeListQuick];
        setQuickHighlightColors(colorCodeListQuick1);
        if (quickToolON && hiddenColorCodesQuick.filter(a => a.highlightColorCode == selectedColor).length > 0) {
            deleteColorSelectionPalateFromSwitch(false, null);
        }
    }, [removedColorsVOList]);
    const toggler = () => {
        // getLatestHighlighColors();
        if (quickToolON) {
            document.querySelector('.colorPalateBtnContainer').style.display = "inline";
        }
        else {
            setChecked(true);
            document.querySelector('.colorPalateBtnContainer').style.display = "inline";
            //checked ? document.querySelector('.colorPalateBtnContainer').style.display="none" : document.querySelector('.colorPalateBtnContainer').style.display="inline";
        }
        let localColorId = localStorage.getItem('QuickHighSelectedColor');
        let localColorCode = localStorage.getItem('QuickHighSelectedColorCode');
        if (localColorId !== undefined && localColorId !== null && localColorId !== "" && localColorCode !== undefined && localColorCode !== null && localColorCode !== "") {
            if (localColorId === "quickUnderLine") {
                setSelectedUnderLine(true);
            }
            else {
                let colorID1 = document.getElementById(localColorId);
                ReactDOM.render(<GrFormClose id={localColorCode} className="quickHLSelectedColor" style={{ left: colorID1.offsetLeft - 8 + "px" }} />, colorID1);
                if (localColorId === "colorBtnTypeOne") { setColorBtnTypeOne(true) }
                else if (localColorId === "colorBtnTypeTwo") { setColorBtnTypeTwo(true); }
                else if (localColorId === "colorBtnTypeThree") { setColorBtnTypeThree(true); }
                else if (localColorId === "colorBtnTypeFour") { setColorBtnTypeFour(true); }
                else if (localColorId === "colorBtnTypeFive") { setColorBtnTypeFive(true); }
                else if (localColorId === "colorBtnTypeSix") { setColorBtnTypeSix(true); }
                else if (localColorId === "colorBtnTypeSeven") { setColorBtnTypeSeven(true); }
                else if (localColorId === "colorBtnTypeEight") { setColorBtnTypeEight(true); }
                else if (localColorId === "colorBtnTypeNine") { setColorBtnTypeNine(true); }
                else if (localColorId === "colorBtnTypeTen") { setColorBtnTypeTen(true); }
                else if (localColorId === "colorBtnTypeEleven") { setColorBtnTypeEleven(true); }
            }
            props.handleQuickToolInputs(true, localColorCode);
            setQuickToolON(true);
            setSelectedColor(localColorCode);
        }
    }
    const colorSelectionPalate = (event, colorCode) => {
        let quickHighlightSwitchHandle = document.querySelector('.quickHighlightContainer button.ant-switch .ant-switch-handle');
        let quickHighlightChecked = document.querySelector('.quickHighlightContainer button.ant-switch').getAttribute('aria-checked');
        let crossClose_rt = document.querySelector('.quickHighlightContainer .crossClose_rt');
        let underline_rt = document.querySelector('.quickHighlightContainer .underline_rt');
        quickHighlightChecked === "true" ? quickHighlightSwitchHandle.classList.add('ant-switched-handle') : quickHighlightSwitchHandle.classList.remove('ant-switched-handle');
        setColorBtnTypeOne(false)
        setColorBtnTypeTwo(false);
        setColorBtnTypeThree(false);
        setColorBtnTypeFour(false);
        setColorBtnTypeFive(false);
        setColorBtnTypeSix(false);
        setColorBtnTypeSeven(false);
        setColorBtnTypeEight(false);
        setColorBtnTypeNine(false);
        setColorBtnTypeTen(false);
        setColorBtnTypeEleven(false);
        let removeCloseIcon = document.querySelectorAll('.colorPalateBtnContainer .colorPalateBtn');
        for (let i = 0; i < removeCloseIcon.length; i++) {
            ReactDOM.unmountComponentAtNode(document.getElementById(removeCloseIcon[i].id));
        }
        setSelectedUnderLine(false);
        let btnID = event.currentTarget.id;
        let colorID = document.getElementById(btnID);
        localStorage.setItem('QuickHighSelectedColor', btnID);
        localStorage.setItem('QuickHighSelectedColorCode', colorCode);
        if (btnID === "quickUnderLine") {
            setSelectedUnderLine(true);
        }
        else {
            ReactDOM.render(<GrFormClose id={colorCode} className="quickHLSelectedColor" style={{ left: colorID.offsetLeft - 8 + "px" }} />, colorID);
            if (btnID === "colorBtnTypeOne") { setColorBtnTypeOne(true) }
            else if (btnID === "colorBtnTypeTwo") { setColorBtnTypeTwo(true); }
            else if (btnID === "colorBtnTypeThree") { setColorBtnTypeThree(true); }
            else if (btnID === "colorBtnTypeFour") { setColorBtnTypeFour(true); }
            else if (btnID === "colorBtnTypeFive") { setColorBtnTypeFive(true); }
            else if (btnID === "colorBtnTypeSix") { setColorBtnTypeSix(true); }
            else if (btnID === "colorBtnTypeSeven") { setColorBtnTypeSeven(true); }
            else if (btnID === "colorBtnTypeEight") { setColorBtnTypeEight(true); }
            else if (btnID === "colorBtnTypeNine") { setColorBtnTypeNine(true); }
            else if (btnID === "colorBtnTypeTen") { setColorBtnTypeTen(true); }
            else if (btnID === "colorBtnTypeEleven") { setColorBtnTypeEleven(true); }
        }
        props.handleQuickToolInputs(true, colorCode);
        setQuickToolON(true);
        quickHighlightSwitchHandle.classList.add('ant-switched-handle');
        setSelectedColor(colorCode);
    }
    const deleteColorSelectionPalate = (e) => {
        let colorBtId = e.currentTarget.id;
        if (colorBtId === "quickHLSelectedUnderLine") {
            setSelectedUnderLine(false);
        }
        else {
            colorBtId = e.currentTarget.id;
            ReactDOM.unmountComponentAtNode(document.getElementById(colorBtId));
            if (colorBtId === "colorBtnTypeOne") { setColorBtnTypeOne(false); }
            else if (colorBtId === "colorBtnTypeTwo") { setColorBtnTypeTwo(false); }
            else if (colorBtId === "colorBtnTypeThree") { setColorBtnTypeThree(false); }
            else if (colorBtId === "colorBtnTypeFour") { setColorBtnTypeFour(false); }
            else if (colorBtId === "colorBtnTypeFive") { setColorBtnTypeFive(false); }
            else if (colorBtId === "colorBtnTypeSix") { setColorBtnTypeSix(false); }
            else if (colorBtId === "colorBtnTypeSeven") { setColorBtnTypeSeven(false); }
            else if (colorBtId === "colorBtnTypeEight") { setColorBtnTypeEight(false); }
            else if (colorBtId === "colorBtnTypeNine") { setColorBtnTypeNine(false); }
            else if (colorBtId === "colorBtnTypeTen") { setColorBtnTypeTen(false); }
            else if (colorBtId === "colorBtnTypeEleven") { setColorBtnTypeEleven(false); }
        }
        let quickHighlightSwitchHandle = document.querySelector('.quickHighlightContainer button.ant-switch .ant-switch-handle');
        quickHighlightSwitchHandle.classList.remove('ant-switched-handle');
        document.querySelector('.colorPalateBtnContainer').style.display = "none";
        props.handleQuickToolInputs(false, "");
        setQuickToolON(false);
        setSelectedColor("");
        localStorage.removeItem('QuickHighSelectedColor');
        localStorage.removeItem('QuickHighSelectedColorCode');
    }
    const deleteColorSelectionPalateFromSwitch = (checked, event) => {
        if (event != null) {
            event.stopPropagation();
        }
        if (!checked) {
            let currentSelectedHighlight = document.querySelector('.quickHighlightContainer button svg');
            let SelectedButtonId = currentSelectedHighlight ? currentSelectedHighlight.parentElement.id : document.querySelector('.quickHighlightContainer svg').id;
            let colorBtId = SelectedButtonId;
            if (colorBtId === "quickHLSelectedUnderLine") {
                setSelectedUnderLine(false);
            }
            else {
                colorBtId = SelectedButtonId;
                ReactDOM.unmountComponentAtNode(document.getElementById(colorBtId));
                if (colorBtId === "colorBtnTypeOne") { setColorBtnTypeOne(false); }
                else if (colorBtId === "colorBtnTypeTwo") { setColorBtnTypeTwo(false); }
                else if (colorBtId === "colorBtnTypeThree") { setColorBtnTypeThree(false); }
                else if (colorBtId === "colorBtnTypeFour") { setColorBtnTypeFour(false); }
                else if (colorBtId === "colorBtnTypeFive") { setColorBtnTypeFive(false); }
                else if (colorBtId === "colorBtnTypeSix") { setColorBtnTypeSix(false); }
                else if (colorBtId === "colorBtnTypeSeven") { setColorBtnTypeSeven(false); }
                else if (colorBtId === "colorBtnTypeEight") { setColorBtnTypeEight(false); }
                else if (colorBtId === "colorBtnTypeNine") { setColorBtnTypeNine(false); }
                else if (colorBtId === "colorBtnTypeTen") { setColorBtnTypeTen(false); }
                else if (colorBtId === "colorBtnTypeEleven") { setColorBtnTypeEleven(false); }
            }
            let quickHighlightSwitchHandle = document.querySelector('.quickHighlightContainer button.ant-switch .ant-switch-handle');
            quickHighlightSwitchHandle.classList.remove('ant-switched-handle');
            document.querySelector('.colorPalateBtnContainer').style.display = "none";
            props.handleQuickToolInputs(false, "");
            setQuickToolON(false);
            setSelectedColor("");
            localStorage.removeItem('QuickHighSelectedColor');
            localStorage.removeItem('QuickHighSelectedColorCode');
        } else {
            toggler();
        }
    }
    const handleClickAwayFromColorPalete = (e) => {
        document.querySelector('.colorPalateBtnContainer').style.display = "none";
    }
    return (
        <ClickAwayListener onClickAway={handleClickAwayFromColorPalete}>
            <div data-testid="quick_highlight_container" className="quickHighlightContainer" role="region" label="quick highlight" aria-label="quick highlight" onClick={toggler}>
                <Switch data-testid="quick_highlight_switch" id="quickHighlightSwitch" aria-haspopup="true" aria-controls="colorPalateBtnContainer" aria-expanded={checked} checked={quickToolON}
                    aria-label="QuickHighlightSwitch" onChange={deleteColorSelectionPalateFromSwitch}
                />
                <label className="quickHighlightTxt mLeftFive mRightFive">Quick Highlight</label>
                <div id="colorPalateBtnContainer" role="menu" aria-labelledby="quickHighlightSwitch" className="colorPalateBtnContainer" style={{ display: 'none' }}>
                    {
                        quickHighlightColors.map((cc, index) => {
                            if (cc.id === "underLine") {
                                return selectedUnderLine ? <GrFormClose data-testid="quick_highlight_underLine_deSelect" key={index} id="quickHLSelectedUnderLine" aria-label="underLine" title="underLine" className="quickHLSelectedUnderLine" onClick={(e) => deleteColorSelectionPalate(e)} /> :
                                    <AiOutlineUnderline data-testid="quick_highlight_underLine_select" key={index} aria-label="underLine" title="underLine" className="underline_rt" onClick={(e) => colorSelectionPalate(e, 'underLine')} id="quickUnderLine" />
                            }
                            else {
                                if (cc.stateValue === "colorBtnTypeOne") {
                                    return <button data-testid="quick_highlight_colorBtnTypeOne" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeOne ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeTwo") {
                                    return <button data-testid="quick_highlight_colorBtnTypeTwo" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeTwo ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeThree") {
                                    return <button data-testid="quick_highlight_colorBtnTypeThree" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeThree ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeFour") {
                                    return <button data-testid="quick_highlight_colorBtnTypeFour" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeFour ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeFive") {
                                    return <button data-testid="quick_highlight_colorBtnTypeFive" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeFive ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeSix") {
                                    return <button data-testid="quick_highlight_colorBtnTypeSix" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeSix ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeSeven") {
                                    return <button data-testid="quick_highlight_colorBtnTypeSeven" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeSeven ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeEight") {
                                    return <button data-testid="quick_highlight_colorBtnTypeEight" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeEight ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeNine") {
                                    return <button data-testid="quick_highlight_colorBtnTypeNine" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeNine ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeTen") {
                                    return <button data-testid="quick_highlight_colorBtnTypeTen" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeTen ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                                else if (cc.stateValue === "colorBtnTypeEleven") {
                                    return <button data-testid="quick_highlight_colorBtnTypeEleven" key={index} className="colorPalateBtn" style={{ background: cc.color }} aria-label={cc.title} title={cc.title} onClick={(e) => colorBtnTypeEleven ? deleteColorSelectionPalate(e) : colorSelectionPalate(e, cc.color)} id={cc.id} type="button"></button>
                                }
                            }
                        })
                    }
                </div>
            </div>
        </ClickAwayListener>
    );
}
export default QuickHighlightShowColorPalete;